import { createContext } from 'react';
import { Subscription, SubscriptionDetails } from 'src/models/subscription';
import { SubscriptionPlan } from 'src/models/subscription-plans';

export interface SubscriptionResult {
  clientSecret?: string;
  subscriptionId?: string;
  [key: string]: unknown;
}

export interface SubscriptionContextType {
  subscriptionPlans: SubscriptionPlan[];
  subscribeSubscription: (id: string, data: Partial<SubscriptionDetails>) => Promise<boolean>;
  subResult: SubscriptionResult | undefined;
  subscriptions: Subscription[];
  nextBillingAmount: number;
  updateNextBillingAmount: (amount: number, users: number) => void;
  cancelSubscriptionPlan: (id: string) => void;
  getSubscriptionDetails: (organization: string) => void;
}

export const SubscriptionContext = createContext<SubscriptionContextType>(
  {} as SubscriptionContextType
);
